import useErrorStore from "../../store/error/error";

export const applicationError = (payload) => {
  useErrorStore.getState().setError(payload);
  return {
    type: "APPLICATION_ERROR",
    payload,
  };
};

export const resetError = () => {
  useErrorStore.getState().resetError();
  return {
    type: "RESET_ERROR",
  };
};
